import { PageType } from "@product/scmp-sdk";
import type { FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import {
  OvalBottomBackground,
  OvalUpperBackground,
} from "scmp-app/components/posties/content-homepage/oval-background";
import { tracking } from "scmp-app/data";
import type { thingsToDoQuery$key } from "scmp-app/queries/__generated__/thingsToDoQuery.graphql";

import Misc from "./misc.png";
import Pig from "./pig.png";
import {
  BackgroundContainer,
  BubbleContainer,
  Container,
  ContentContainer,
  MiscContainer,
  PigBubbleContainer,
  PigContainer,
  StyledBackground,
  StyledBubble,
  StyledContentItemPostiesPrimary,
  StyledHeadline,
  StyledPigImage,
  Wrapper,
} from "./styles";
type Props = {
  reference: thingsToDoQuery$key;
};

export const ThingsToDo: FunctionComponent<Props> = ({ reference: reference_ }) => {
  const data = useFragment(
    graphql`
      fragment thingsToDoQuery on Query {
        thingsToDoSection: section(filter: { entityId: "515465" }) {
          ...headlineSection
        }
        thingsToDoQueue: queue(filter: { name: "section_top_515465" }) {
          items(first: 1) {
            __typename
            edges {
              node {
                ... on Article {
                  ...postiesPrimaryContentItemContent
                }
              }
            }
          }
        }
      }
    `,
    reference_,
  );

  const items = data?.thingsToDoQueue?.items?.edges;

  const customQueryParameters = {
    module: tracking.module.ThingsToDo,
    pgtype: tracking.pageType.Content,
  };

  return (
    <Wrapper>
      <PigBubbleContainer>
        <BubbleContainer>
          <StyledBubble />
        </BubbleContainer>
        <PigContainer>
          <StyledPigImage alt={Pig.alt} src={Pig.src} />
        </PigContainer>
      </PigBubbleContainer>
      <Container>
        <OvalUpperBackground $ovalFillColor="#33ABBC" $rectFillColor="#FFFFFF" />
        <BackgroundContainer>
          <StyledBackground />
        </BackgroundContainer>
        <ContentContainer>
          <StyledHeadline
            color="#FFFCF2"
            query={{
              pageType: PageType.PostiesSection,
              ...customQueryParameters,
            }}
            reference={data.thingsToDoSection}
          />
          {items?.map((item, key) => (
            <StyledContentItemPostiesPrimary
              customQueryParameters={{
                pageType: PageType.PostiesArticle,
                ...customQueryParameters,
              }}
              key={key}
              reference={item.node}
            />
          ))}
        </ContentContainer>
        <MiscContainer>
          <img alt={Misc.alt} src={Misc.src} />
        </MiscContainer>
        <OvalBottomBackground $ovalFillColor="#33ABBC" $rectFillColor="#fcf5de" />
      </Container>
    </Wrapper>
  );
};
ThingsToDo.displayName = "ThingsToDo";
